//引入接口文档
import req from '@/utils/req.js'
import axios from "axios";
//获取教程列表
export function courseList(params) {
    return req.get("/admin/train-course/page", params);
}
//新增教程
export function addCourse(params) {
    return req.post("/admin/train-course", params);
}
//获取章节
export function courseId(params) {
    return req.get("/admin/train-chapter/tree", params);
}
//编辑教程
export function editCourse(params) {
    return req.put("/admin/train-course", params);
}
//删除教程
export function deleteCourse(params) {
    return req.delete(`/admin/train-course/${params.id}`);
}
//停用教程
export function disabledColumn(params) {
    return req.put(`/admin/train-course/disabled?id=${params.id}`);
}
//启用教程
export function enabledColumn(params) {
    return req.put(`/admin/train-course/enabled?id=${params.id}`);
}
//批量推送教程
export function batchCourse(params) {
    return req.post("/admin/train-chapter/batch", params);
}
//引用教程
export function quoteCourse(params) {
    return req.get(`/admin/train-course/quote/${params.id}`);
}
//获取线下机构
export function apiDepartmentScreen(params) {
    return req.post("/admin/hospital/listPullDown", params);
}
//拖拽章节
export function changeChapterNo(params) {
    return req.post("/admin/train-chapter/changeChapterNo", params);
}


